/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionDetailRespone } from '../../models/session-detail-respone';

export interface HealthFindrSessionDetailSessionIdGet$Params {
  sessionId: string;
}

export function healthFindrSessionDetailSessionIdGet(http: HttpClient, rootUrl: string, params: HealthFindrSessionDetailSessionIdGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<SessionDetailRespone>> {
  const rb = new RequestBuilder(rootUrl, healthFindrSessionDetailSessionIdGet.PATH, 'get');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<SessionDetailRespone>;
    })
  );
}

healthFindrSessionDetailSessionIdGet.PATH = '/HealthFindr/SessionDetail/{sessionId}';
